import { useConfig } from '../lib/ConfigContext';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { AppleLogo } from '../components/AppleLogo';

export function LoginPage() {
  const config = useConfig();
  const { signIn, isAuthenticated } = useAuth();
  const [params] = useSearchParams();
  const error = params.get('error');

  if (isAuthenticated) return <Navigate to={config.conciergeOnly ? "/concierge" : "/"} replace />;

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#F7F7F5]">
      <div className="max-w-md w-full">
        <div className="text-center mb-10">
          <div className="wordmark text-5xl mb-3">
            MANOR
          </div>
          <div className="text-slate-600 text-[11px] uppercase tracking-[0.28em] font-medium">
            Admin Portal
          </div>
        </div>

        <div className="bg-white backdrop-blur border border-slate-200 rounded-2xl p-8 shadow-sm">
          <p className="text-sm text-ink-800 mb-6 text-center leading-relaxed">
            {config.conciergeOnly ? 'Sign in to manage MANOR Concierge requests.' : 'Sign in to manage MANOR requests and homes.'}
          </p>

          <button
            onClick={signIn}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-black text-white font-medium hover:bg-neutral-900 active:bg-black border border-white/10 transition shadow-sm"
            style={{ minHeight: 48 }}
          >
            {config.identityProvider !== 'COGNITO' && <AppleLogo size={18} className="-mt-0.5" />}
            <span className="text-[15px]">{config.identityProvider === 'COGNITO' ? 'Sign in' : 'Sign in with Apple'}</span>
          </button>

          {error && (
            <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3">
              {decodeURIComponent(error)}
            </div>
          )}

          <p className="mt-6 text-xs text-slate-600 text-center">
            Restricted access. Only allowlisted admins can sign in.
          </p>
        </div>

        <p className="break-all text-center text-[11px] text-slate-500 mt-6 font-mono tracking-wide">
          {new URL(config.portalUrl).hostname}
        </p>
      </div>
    </div>
  );
}
